import React from "react";
import correct from "../assets/tick_mark.svg";
import inCorrect from "../assets/cross_mark.svg";

function CompItem2(props) {
  return (
    <div className="flex justify-center border-b-[1px]">
      <div className="text-[#5C5A5A] md:text-[24px] border-r-[1px] border-[#D9D9D9] justify-center p-4 font-montserrat flex-none w-[40%]">
        {props.title}
      </div>
      <div className=" flex border-r-[1px] border-[#D9D9D9] place-content-center px-6 py-4 flex-1">
        <img
          src={props.first ? correct : inCorrect}
          alt=""
          className="w-6 md:w-8"
        />
      </div>
      <div className="justify-center flex px-6 py-4 flex-1 place-content-center">
        <img
          src={props.second ? correct : inCorrect}
          alt=""
          className="w-6 md:w-8"
        />
      </div>
    </div>
  );
}

export default CompItem2;
